import { useState } from "react";
import type { UseMutateAsyncFunction } from "@tanstack/react-query";

export function useSendChunks<TData, TVariables>(
  mutateAsync: UseMutateAsyncFunction<TData, unknown, TVariables>,
) {
  const [data, setData] = useState<TData[]>();
  const [progress, setProgress] = useState<number>();
  const [isLoading, setLoading] = useState(false);

  const reset = () => {
    setData(undefined);
    setProgress(0);
  };

  const sendChunks = async (variables: TVariables[]) => {
    setLoading(true);
    let count = 0;

    for (const variable of variables) {
      const data = await mutateAsync(variable);

      count += 1;
      setProgress(Math.round((count * 100) / variables.length));

      setData((prev) => {
        if (!prev) {
          return [data];
        }
        return [...prev, data];
      });
    }

    setLoading(false);
  };

  const isSuccess = data && !isLoading;

  return { data, progress, isLoading, isSuccess, sendChunks, reset };
}
